import { render, staticRenderFns } from "./TokenTable.vue?vue&type=template&id=c1fe7118&scoped=true&"
import script from "./TokenTable.vue?vue&type=script&lang=js&"
export * from "./TokenTable.vue?vue&type=script&lang=js&"
import style0 from "./TokenTable.vue?vue&type=style&index=0&id=c1fe7118&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fe7118",
  null
  
)

export default component.exports